<div class="m-1 lg:m-6 lg:mt-1 mt-1" *ngIf="filteredStatement$ | async as statement">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row my-3">
      <a routerLink="/v2/financials" class="font-semibold text-gray-500 text-3xl mb-3">Daily Payments</a>
      <span class="material-icons text-gray-500 text-3xl"> navigate_next </span>
      <div class="font-semibold text-3xl mb-3">
        {{ statement.statement.month }}/{{ statement.statement.day }}/{{ statement.statement.year }}
      </div>
    </div>
    <div>
      <mat-form-field class="text-xl" *lohiFeatureFlag="'settlementFilterByDriver'">
        <mat-label>Filter Loads By Driver</mat-label>
        <mat-select [formControl]="driverSelectFormControl">
          <mat-option value="All Drivers">All Drivers</mat-option>
          <mat-option *ngFor="let driver of driversOnStatement$ | async; trackBy: null | trackByKey" [value]="driver">{{
            driver
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <a mat-icon-button [routerLink]="['/', 'settlement', 'print', statement.statement.id]" target="_blank">
        <mat-icon>print</mat-icon>
      </a>
    </div>
  </div>
  <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-3 gap-y-3">
    <div>
      <div>
        <div
          class="flex flex-col pb-2 border-gray-400 mb-2 card-with-shadow bg-white p-2"
          [class.border-b]="statement.statement.firstLoadDate && statement.statement.lastLoadDate"
        >
          <div class="font-semibold text-2xl flex justify-between align-middle">
            <div>Summary</div>
          </div>
          <div
            *ngIf="statement.statement.firstLoadDate && statement.statement.lastLoadDate"
            class="text-gray-600 text-lg mt-1"
          >
            Loads From {{ statement.statement.firstLoadDate | standardDateOnly }} -
            {{ statement.statement.lastLoadDate | standardDateOnly }}
          </div>
        </div>
        <div class="card-with-shadow mb-2 bg-white p-2 flex flex-col">
          <div class="flex flex-row justify-between my-1 text-xl font-semibold">
            <div class="font-semibold">Settlement</div>
            <div>{{ statement.statement.month }}/{{ statement.statement.day }}/{{ statement.statement.year }}</div>
          </div>
          <div class="flex flex-row justify-between my-1 text-xl font-semibold">
            <div class="font-semibold">Loads</div>
            <div>{{ statement.statement.orders.length }}</div>
          </div>
          <div class="flex flex-row justify-between my-1 text-xl font-semibold">
            <div class="font-semibold">Payment Status</div>
            <div>{{ statement.statement.paidAt ? 'Paid' : 'Pending' }}</div>
          </div>
        </div>
        <ng-container *ngIf="driverSelectFormControl.value === 'All Drivers'; else filteredLoadSummary">
          <div class="card-with-shadow bg-white p-2 flex flex-col">
            <div class="flex flex-row justify-between py-1 pb-2 text-xl font-semibold">
              <div class="font-semibold">Total Of All Loads</div>
              <div>{{ statement.statement.totalOfAllLoads | currencyInPennies }}</div>
            </div>
            <div class="flex flex-col justify-between py-1 border-b border-gray-400 pb-2">
              <div class="flex flex-row justify-between">
                <div>Daily Credits</div>
                <div>{{ statement.statement.totalCredits | currencyInPennies }}</div>
              </div>
              <ng-container *ngFor="let credit of statement.statement.adjustment; trackBy: 'id' | trackByKey">
                <div class="text-gray-600 flex flex-row justify-between text-sm" *ngIf="credit.totalInPennies > 0">
                  <div class="ml-2">{{ credit.userFacingComment }}</div>
                  <div>{{ credit.totalInPennies | currencyInPennies }}</div>
                </div>
              </ng-container>
              <ng-container *ngFor="let credit of statement.statement.lineItems; trackBy: 'id' | trackByKey">
                <div class="text-gray-600 flex flex-row justify-between text-sm" *ngIf="credit.totalInPennies > 0">
                  <div class="ml-2">{{ credit.description }}</div>
                  <div>{{ credit.totalInPennies | currencyInPennies }}</div>
                </div>
              </ng-container>
            </div>
            <div class="flex flex-row justify-between pt-2 pb-1">
              <div>Daily Deductions</div>
              <div [class.text-red-500]="(totalDeductions$ | async) < 0">
                {{ totalDeductions$ | async | currencyInPennies }}
              </div>
            </div>
            <ng-container
              *ngFor="
                let credit of statement.statement.adjustment;
                trackBy: statement.statement.adjustment | trackByKey2: 'id'
              "
            >
              <div class="text-gray-600 flex flex-row justify-between text-sm" *ngIf="credit.totalInPennies < 0">
                <div class="ml-2">{{ credit.userFacingComment }}</div>
                <div>{{ credit.totalInPennies | currencyInPennies }}</div>
              </div>
            </ng-container>
            <ng-container
              *ngFor="
                let credit of statement.statement.nonOrderLineItems;
                trackBy: statement.statement.nonOrderLineItems | trackByKey2: 'description'
              "
            >
              <ng-container *ngIf="credit.description === 'Fuel Cards'; else regularNonOrderLI">
                <div class="text-gray-600 flex flex-row justify-between text-sm" *ngIf="credit.totalInPennies < 0">
                  <a routerLink="/fuelcard/cards" class="ml-2 text-blue-500">{{ credit.description }} Transactions</a>
                </div>
                <div
                  *ngFor="
                    let tx of statement.statement.fuelTransactions;
                    trackBy: statement.statement.fuelTransactions | trackByKey2: 'id'
                  "
                  class="flex justify-between text-gray-600 text-sm pl-4"
                >
                  <div class="">{{ tx.time | standardDate }}</div>
                  <div class="text-right">{{ -tx.totalInPennies | currencyInPennies }}</div>
                </div>
                <div class="text-gray-600 flex flex-row justify-between text-sm" *ngIf="credit.totalInPennies < 0">
                  <div class="ml-2 font-bold">Total Fuel</div>
                  <div class="border-t border-gray-600">{{ credit.totalInPennies | currencyInPennies }}</div>
                </div>
              </ng-container>
              <ng-template #regularNonOrderLI>
                <div class="text-gray-600 flex flex-row justify-between text-sm" *ngIf="credit.totalInPennies < 0">
                  <div class="ml-2">{{ credit.description }}</div>
                  <div>{{ credit.totalInPennies | currencyInPennies }}</div>
                </div>
              </ng-template>
            </ng-container>
          </div>
          <div class="card-with-shadow bg-white p-2 flex flex-row justify-between text-xl font-semibold mt-2">
            <div class="font-semibold">Total Payable</div>
            <div class="text-green-500">{{ statement.statement.totalPayable | currencyInPennies }}</div>
          </div>
          <div
            class="card-with-shadow bg-white p-2 mt-2 border-blue-300 border-2"
            *ngIf="statement.statement.directDriverPaymentInfo?.length"
          >
            <ng-container
              *ngFor="let directPay of statement.statement.directDriverPaymentInfo; trackBy: trackDirectDriverPay"
            >
              <div class="my-2 pb-2 border-b border-gray-400 last:border-0">
                <div class="font-bold py-1">{{ directPay.userName }}</div>
                <div class="flex justify-between">
                  <div>{{ directPay.description }}</div>
                  <div class="text-right text-lg font-semibold">{{ directPay.totalInPennies | currencyInPennies }}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #filteredLoadSummary>
          <div class="card-with-shadow bg-white p-2 flex flex-col">
            <div class="flex flex-row justify-between py-1 pb-2 text-xl font-semibold">
              <div class="font-semibold">Total Of <span class="font-bold underline">Driver</span> Loads</div>
              <div>{{ locallyCalculatedTotalOfLoads$ | async | currencyInPennies }}</div>
            </div>
            <div class="flex flex-col justify-between py-1 pb-2 text-red-400">
              Credits and deductions are applied at the company level and cannot be filtered by driver. Fuel cards,
              fees, bonuses, etc are NOT included in the number above
            </div>
          </div>
        </ng-template>
      </div>

      <div class="mt-3 flex flex-col">
        <div class="font-semibold">Payable To:</div>
        <div>
          {{ statement.company.name }}
        </div>
        <div>DOT {{ statement.company.dotNumber }}</div>
        <br />
        <div>
          {{ statement.company.address }}
        </div>
      </div>
    </div>
    <div class="flex flex-col col-span-2">
      <ng-container *ngIf="statement.statement.escrowPayouts?.length">
        <div class="text-center font-semibold text-xl">Escrow Adjustment</div>
        <ng-container
          class="py-3"
          *ngFor="
            let payment of statement.statement.escrowPayouts;
            trackBy: statement.statement.escrowPayouts | trackByKey2: 'id'
          "
        >
          <div *ngIf="payment.carrierFacingNotes" class="py-3">
            {{ payment.carrierFacingNotes }}
          </div>
        </ng-container>
        <div class="text-center font-semibold text-lg" *ngIf="statement.statement.files?.length">
          Supporting Documentation
        </div>
        <div
          class="py-3"
          *ngFor="let file of statement.statement.files; trackBy: statement.statement.files | trackByKey2: 'id'"
        >
          <a [href]="file.publicUrl" target="_blank">
            <img *ngIf="file.fileName | isImage" alt="image" [src]="file.publicUrl" class="max-w-25" />
            <div class="text-blue-500 flex items-center">
              {{ file.displayName }}
              <mat-icon inline class="ml-1">open_in_new</mat-icon>
            </div>
          </a>
        </div>
      </ng-container>
      <ng-container
        *ngFor="let order of statement.statement.orders; trackBy: statement.statement.orders | trackByKey2: 'id'"
      >
        <div class="card-with-shadow rounded bg-white mb-3">
          <div class="grid lg:grid-cols-3 lg:gap-1 p-2 bg-gray-700 text-white rounded">
            <div class="ml-2 lg:border-r border-gray-600">
              <div class="font-bold text-xl" *ngIf="order.propxTicketNumber; else loadNumber">
                Ticket #{{ order.propxTicketNumber }}
              </div>
              <ng-template #loadNumber>
                <div class="font-bold text-xl">Load #{{ order.id }}</div>
              </ng-template>
              <div class="font-bold text-xl" *ngIf="order.bolNumber">BOL #{{ order.bolNumber }}</div>
              <div>
                Driver <span class="font-semibold">{{ order.driverName }}</span>
              </div>
            </div>
            <div class="ml-2 col-span-2">
              <div>
                Accepted: <span class="font-semibold">{{ order.acceptTime | standardDate }}</span>
              </div>
              <div>
                Pick Up:
                <span class="font-semibold"
                  >{{ order.pickupLocation.siteTime | standardDate }}, {{ order.pickupLocation.name }}</span
                >
              </div>
              <div>
                Drop Off:
                <span class="font-semibold"
                  >{{ order.dropoffLocation.siteTime | standardDate }}, {{ order.dropoffLocation.name }}</span
                >
              </div>
            </div>
          </div>
          <div class="bg-white">
            <ng-container *ngFor="let lineItem of order.lineItems; trackBy: 'id' | trackByKey">
              <div
                *ngIf="lineItem.totalInPennies > 0"
                class="mx-3 flex flex-row justify-between py-2 border-b border-gray-400 last:border-0"
              >
                <div>{{ lineItem.description }}</div>
                <div class="font-bold" [class.text-red-500]="lineItem.totalInPennies < 0">
                  {{ lineItem.totalInPennies | currencyInPennies }}
                </div>
              </div>
            </ng-container>
            <div>
              <mat-accordion>
                <mat-expansion-panel [hideToggle]="true" [expanded]="true" class="mat-elevation-z0" #expansionPanel>
                  <mat-expansion-panel-header class="w-full">
                    <div class="flex flex-row justify-between w-full">
                      <div class="flex flex-row items-center">
                        Deductions
                        <mat-icon class="ml-1">{{ expansionPanel.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                      </div>
                      <div class="font-bold" [class.text-red-500]="order.totalDeductions < 0">
                        {{ order.totalDeductions | currencyInPennies }}
                      </div>
                    </div>
                  </mat-expansion-panel-header>
                  <ng-container *ngFor="let lineItem of order.lineItems; trackBy: 'id' | trackByKey">
                    <div
                      *ngIf="lineItem.totalInPennies < 0"
                      class="ml-3 flex flex-row justify-between py-2 border-b border-gray-400 text-gray-600 last:border-0"
                    >
                      <div>{{ lineItem.description }}</div>
                      <div>
                        {{ lineItem.totalInPennies | currencyInPennies }}
                      </div>
                    </div>
                  </ng-container>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
          <div class="border-t border-gray-900 flex flex-row justify-between px-3 p-2">
            <div>Load Total</div>
            <div class="text-green-500 font-bold">{{ order.loadTotalInPennies | currencyInPennies }}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
